import axios from '@/util/request'

// 销售订单统计

// 表头/com/had-login/shopp-order/statisticsHeader
export const statisticsHeader = (params) => {
    return axios({
      url: '/com/had-login/shopp-order/statisticsHeader',
      method: 'get',
      params
    })
}

// 销量/com/had-login/shopp-order/statisticsSalesVolume
export const statisticsSalesVolume = (params) => {
    return axios({
      url: '/com/had-login/shopp-order/statisticsSalesVolume',
      method: 'get',
      params
    })
}

// 销售额/com/had-login/shopp-order/statisticsSalesQuota
export const statisticsSalesQuota = (params) => {
    return axios({
      url: '/com/had-login/shopp-order/statisticsSalesQuota',
      method: 'get',
      params
    })
}

// 中学统计
// /com/had-login/shopp-order/statisticsMiddleSchool
export const statisticsMiddleSchool = (params) => {
  return axios({
    url: '/com/had-login/shopp-order/statisticsMiddleSchool',
    method: 'get',
    params
  })
}

// 员工销售统计
// 员工销售统计销量/com/had-login/shopp-order/statisticsStaffVolume
export const statisticsStaffVolume = (params) => {
  return axios({
    url: '/com/had-login/shopp-order/statisticsStaffVolume',
    method: 'get',
    params
  })
}

// 员工销售统计销额/com/had-login/shopp-order/statisticsStaffVolume
export const statisticsStaffQuota = (params) => {
  return axios({
    url: '/com/had-login/shopp-order/statisticsStaffQuota',
    method: 'get',
    params
  })
}

// /com/had-login/lecture-info/statisticsParticipation讲座参加统计
// 请求examProvince isContract
// 返回realName contactPhone  schoolName disciplineType isSignUp isJoin isContract(1签约 0未签约)
export const statisticsParticipation = (data) => {
  return axios({
    url: '/com/had-login/lecture-info/statisticsParticipation',
    method: 'post',
    data
  })
}

// /com/had-login/lecture-info/statisticsSchool学校累计参加讲座人数
// 请求examProvince years
// 返回  schoolName isSignUp isJoin
export const statisticsSchool = (data) => {
  return axios({
    url: '/com/had-login/lecture-info/statisticsSchool',
    method: 'post',
    data
  })
}

// /com/had-login/lecture-info/statisticsCumulativeParticipation
// 累计参加讲座人数
export const statisticsCumulativeParticipationl = (data) => {
  return axios({
    url: '/com/had-login/lecture-info/statisticsCumulativeParticipation',
    method: 'post',
    data
  })
}

// /com/had-login/stu/student-info/getStudentStatistics
// 用户关注统计
export const getStudentStatistics = (params) => {
  return axios({
    url: '/com/had-login/stu/student-info/getStudentStatistics',
    method: 'get',
    params

  })
}

// 分子公司统计设置
// /com/had-login/st-company-config/getCompanyPage
// 公司列表
export const getCompanyPage = (data) => {
  return axios({
    url: '/com/had-login/st-company-config/getCompanyPage',
    method: 'post',
    data
  })
}

// /com/had-login/st-company-config/addCompany
// 添加公司
export const addCompany = (data) => {
  return axios({
    url: '/com/had-login/st-company-config/addCompany',
    method: 'post',
    data
  })
}

// /com/had-login/st-company-config/deleteCompany
// 删除公司
export const deleteCompany = (params) => {
  return axios({
    url: '/com/had-login/st-company-config/deleteCompany',
    method: 'get',
    params
  })
}

// /com/had-login/st-company-config/getCompanyIds
// getCompanyIds
export const getCompanyIds = (params) => {
  return axios({
    url: '/com/had-login/st-company-config/getCompanyIds',
    method: 'get',
    params
  })
}

// 区域公司统计设置
// POST /com/had-login/st-area-config/getAreaConfigPage
// 区域公司列表
export const getAreaConfigPage = (data) => {
  return axios({
    url: '/com/had-login/st-area-config/getAreaConfigPage',
    method: 'post',
    data
  })
}

// /com/had-login/st-area-config/addAreaConfig
// 添加区域公司
export const addAreaConfig = (data) => {
  return axios({
    url: '/com/had-login/st-area-config/addAreaConfig',
    method: 'post',
    data
  })
}

// /com/had-login/st-area-config/deleteCompany
// 删除区域内的公司
export const areadeleteCompany = (params) => {
  return axios({
    url: '/com/had-login/st-area-config/deleteCompany',
    method: 'get',
    params
  })
}

// /com/had-login/st-area-config/deleteAreaConfig
// 删除区域公司
export const deleteAreaConfig = (params) => {
  return axios({
    url: '/com/had-login/st-area-config/deleteAreaConfig',
    method: 'get',
    params
  })
}

// 分子公司统计
// /com/had-login/st-company-config/statisticsHeader
// 分子公司统计表头
export const statisticsHeadercompany = (params) => {
  return axios({
    url: '/com/had-login/st-company-config/statisticsHeader',
    method: 'get',
    params
  })
}


// /com/had-login/st-company-config/statisticsSalesVolume
// 分子公司统计销量(销售时间)
export const statisticsSalesVolumecompany = (params) => {
  return axios({
    url: '/com/had-login/st-company-config/statisticsSalesVolume',
    method: 'get',
    params
  })
}

// /com/had-login/st-company-config/statisticsSalesQuota
// 分子公司统计销售额(销售时间)
export const statisticsSalesQuotacompany = (params) => {
  return axios({
    url: '/com/had-login/st-company-config/statisticsSalesQuota',
    method: 'get',
    params
  })
}

// /com/had-login/shopp-order/statisticsExpert
// 专家接待
export const statisticsExpert = (params) => {
  return axios({
    url: '/com/had-login/shopp-order/statisticsExpert',
    method: 'get',
    params
  })
}

// /com/had-login/st-area-config/statisticsAreaSalesVolume
// 区域公司统计销量(销售时间)
export const statisticsAreaSalesVolume = (params) => {
  return axios({
    url: '/com/had-login/st-area-config/statisticsAreaSalesVolume',
    method: 'get',
    params
  })
}

// /com/had-login/st-area-config/statisticsAreaSalesQuota
// 区域公司统计销售额(销售时间
export const statisticsAreaSalesQuota = (params) => {
  return axios({
    url: '/com/had-login/st-area-config/statisticsAreaSalesQuota',
    method: 'get',
    params
  })
}

// /com/had-login/st-area-config/statisticsAreaHeader
// 区域公司统计表头
export const statisticsAreaHeader = (params) => {
  return axios({
    url: '/com/had-login/st-area-config/statisticsAreaHeader',
    method: 'get',
    params
  })
}

// /com/had-login/st-area-config/statisticsCompanyHeader
// 区域的公司统计表头
export const statisticsCompanyHeader = (params) => {
  return axios({
    url: '/com/had-login/st-area-config/statisticsCompanyHeader',
    method: 'get',
    params
  })
}

// /com/had-login/st-area-config/statisticsCompanySalesQuota
// 区域公司-公司统计销售额(销售时间)
export const statisticsCompanySalesQuota = (params) => {
  return axios({
    url: '/com/had-login/st-area-config/statisticsCompanySalesQuota',
    method: 'get',
    params
  })
}

// /com/had-login/st-area-config/statisticsCompanySalesVolume
// 区域公司-公司统计销量(销售时间
export const statisticsCompanySalesVolume = (params) => {
  return axios({
    url: '/com/had-login/st-area-config/statisticsCompanySalesVolume',
    method: 'get',
    params
  })
}

// /com/had-login/lecture-info/statisticsCumulativeParticipationSum
// 参加讲座人数统计
export const statisticsCumulativeParticipationSum = (data) => {
  return axios({
    url: '/com/had-login/lecture-info/statisticsCumulativeParticipationSum',
    method: 'post',
    data
  })
}

//had-login/st-area-config/updateSort
// 区域统计设置排序
export const areaStatisticsSettingSort = (params) => {
  return axios({
    url: '/com/had-login/st-area-config/updateSort',
    method: 'get',
    params
  })
}


//had-login/st-company-config/updateSort
// 区域统计设置排序
export const companyStatisticsSettingSort = (params) => {
  return axios({
    url: '/com/had-login/st-company-config/updateSort',
    method: 'get',
    params
  })
}

// 销量/com/had-login/shopp-order/statisticsSalesVolume
export const statisticsSalesToExecl = (params) => {
  return axios({
    url: '/com/had-login/shopp-order/statisticsSalesToExecl',
    method: 'get',
    params,
    responseType: "blob",
  })
}

//GET com/had-login/channel/app-channel/getChannelHeader
// APP统计表头
export const getChannelHeader = (params) => {
  return axios({
    url: '/com/had-login/channel/app-channel/getChannelHeader',
    method: 'get',
    params
  })
}

//GET com/had-login/channel/app-channel/getAppOrderVolumeStatistics
// 获取APP订单统计
export const getAppOrderVolumeStatistics = (params) => {
  return axios({
    url: '/com/had-login/channel/app-channel/getAppOrderVolumeStatistics',
    method: 'get',
    params
  })
}

//GET com/had-login/channel/app-channel/getAppUserVolumeStatistics
// 获取APP用户统计
export const getAppUserVolumeStatistics = (params) => {
  return axios({
    url: '/com/had-login/channel/app-channel/getAppUserVolumeStatistics',
    method: 'get',
    params
  })
}